import React, { createContext, useContext, useState, useEffect } from 'react';

const PurchaseContext = createContext();

export const usePurchase = () => useContext(PurchaseContext);

export const PurchaseProvider = ({ children }) => {
  const [purchase, setPurchase] = useState(() => {
    const savedPurchase = localStorage.getItem('purchase');
    return savedPurchase ? JSON.parse(savedPurchase) : null;
  });

  const updatePurchase = (updatedPurchase) => {
    setPurchase(updatedPurchase);
  };

  const clearPurchase = () => {
    setPurchase(null);
    localStorage.removeItem('purchase');
  };

  useEffect(() => {
    if (purchase) {
      localStorage.setItem('purchase', JSON.stringify(purchase));
    }
  }, [purchase]);

  return (
    <PurchaseContext.Provider value={{ purchase, updatePurchase, clearPurchase }}>
      {children}
    </PurchaseContext.Provider>
  );
};